import { SIDE_NAV_DARK, NAV_TYPE_SIDE, DIR_LTR } from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const SERVER_BASE_URL = env.API_ENDPOINT_URL;
export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? env.API_ENDPOINT_URL
    : env.API_ENDPOINT_URL.concat("api/");
export const HEADER_TOKEN = "Authorization";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_DARK,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};
